import { RouteObject } from 'react-router-dom';
import { RANKING_PATH } from './StatisticsLinks';
import RankingPage from './pages/RankingPage';
import StatisticsPage from './pages/StatisticsPage';

export const StatisticsRoutes: RouteObject[] = [
  {
    path: '',
    children: [
      {
        index: true,
        element: <StatisticsPage />,
      },
      {
        path: RANKING_PATH,
        element: <RankingPage />,
      },
    ],
  },
];
